import { API } from 'aws-amplify'

import { VAULT_ENDPOINT } from './constants'
import routes from './routes'
import actionTypes from 'store/actions'
import moment from 'moment'
import * as log from './log'

// async getBusinessData(businessId) {
//   try {
//     const business = await this.api.get(DEFAULT_ENDPOINT, routes.getBusiness, {
//       queryStringParameters: {
//         business_id: businessId,
//       },
//     })

//     return business?.details
//   } catch (error) {
//     console.error(error)
//   }
// }

/*NOTE: For verification */
export const fetchVaultSummary = async (dispatch, business_id) => {
  const queryStringParameters = { business_id }
  dispatch({ type: actionTypes.VAULTFETCHINGSUMMARY })
  try {
    let summaryDetails = await API.get(VAULT_ENDPOINT, routes.getVaultSummary, { queryStringParameters })
    log.logResponse('GET', routes.getVaultSummary, summaryDetails)
    dispatch({ type: actionTypes.VAULTFETCHINGSUMMARYDONE, payload: summaryDetails.details })
  } catch (err) {
    dispatch({ type: actionTypes.VAULTFETCHINGSUMMARYDONE, payload: { vault_verfied: false } })
    throw err
  }
}

export const sendVerificationCode = async vault_id => {
  const body = { vault_id }
  try {
    let generateRes = await API.post(VAULT_ENDPOINT, routes.vaultOTP + '/generate', { body })
    log.logResponse('POST', routes.vaultOTP + '/generate', generateRes)
  } catch (err) {
    //NOTE: Check if the error due to network connection.
    throw err
  }
}

export const otpVerify = (dispatch, vault_id, otpCode) => {
  // Register Vault for first attempt
  dispatch({ type: actionTypes.VAULTOPTVERIFYSTARTED })
  const body = {
    otp_code: otpCode,
    vault_id,
  }
  return API.post(VAULT_ENDPOINT, routes.vaultOTP + '/verify', { body })
  .then((res)=>{
    log.logResponse('POST', routes.vaultOTP + '/verify', res)
    dispatch({ type: actionTypes.VAULTOTPVERIFYDONE })
  })
  .catch((err)=>{
    log.logError('POST', routes.vaultOTP + '/verify', err)
    dispatch({ type: actionTypes.VAULTOTPVERIFYFAILED })
    throw err
  })
}

/*NOTE: Vault Documents API */

/*TODO: Completed pagination */
export const fetchDocuments = async (dispatch, vault_id, pageNo = 1, pageSize = 100) => {
  const queryStringParameters = {
    vault_id,
    pageNo,
    pageSize,
  }
  log.logRequest('GET', routes.vaultDocument, queryStringParameters)

  dispatch({ type: actionTypes.VAULTFETCHINGDOCUMENTS })
  try {
    let res = await API.get(VAULT_ENDPOINT, routes.vaultDocument, { queryStringParameters })
    log.logResponse('GET', routes.vaultDocument, res)
    dispatch({ type: actionTypes.VAULTFETCHINGDOCUMENTSDONE, payload: res })
  } catch (err) {
    dispatch({ type: actionTypes.VAULTFETCHINGDOCUMENTSDONE, payload: { details: [] } })
    throw err
  }
}

export const submitDocumentHistory = async (vault_id, document_id, operation) => {
  //TODO: check what is required to remove BOs from backend request. Check boId fields
  const body = { vault_article_id: document_id, operation }
  log.logRequest('POST', routes.vaultDocument + '/hisotry', body)

  try {
    let postHistoryRes = await API.post(VAULT_ENDPOINT, routes.vaultDocument + '/history', { body })
    log.logResponse('POST', routes.vaultDocument + '/history', postHistoryRes)
    //NOTE: Once BOs are removed and re-fetch
  } catch (err) {
    log.logError('POST', routes.vaultBO, err)
  }
}


export const submitBOInformation = (updatedCheck, callBack) => {
  callBack({ isOpen: false, type: 'success', message: '' })
  const body = { details: [...updatedCheck] }
  API.put(VAULT_ENDPOINT, routes.vaultBOdisplay, { body })
    .then(res => {
      callBack &&
        callBack({
          isOpen: true,
          type: 'success',
          message: 'Successfully updated ownership information',
        })
    })
    .catch(
      err =>
        callBack &&
        callBack({
          isOpen: true,
          type: 'error',
          message: 'Something went wrong. Please try again.',
        }),
    )
}




export const fetchDocumentHistory = async (
  vault_id,
  vault_article_id,
  pageNo = 1,
  pageSize = 100,
  sortBy = '-date',
) => {
  const queryStringParameters = {
    vault_article_id,
    pageNo,
    pageSize,
    sortBy,
  }
  log.logRequest('GET', routes.vaultDocument + '/history', queryStringParameters)

  try {
    let res = await API.get(VAULT_ENDPOINT, routes.vaultDocument + '/history', { queryStringParameters })
    log.logResponse('GET', routes.vaultDocument + '/history', res)
    return res
  } catch (err) {
    throw err
  }
}

export const submitBOHistory = async (beneficial_owner_id, operation) => {
  const body = { beneficial_owner_id, operation }
  log.logRequest('POST', routes.vaultBO + '/history', body)

  try {
    let postHistoryRes = await API.post(VAULT_ENDPOINT, routes.vaultBO + '/history', { body })
    log.logResponse('POST', routes.vaultBO + '/history', postHistoryRes)
  } catch (err) {
    log.logError('POST', routes.vaultBO, err)
  }
}

export const fetchBODHistory = async (
  pageNo = 1,
  pageSize = 10,
  beneficial_owner_id

) => {
  const queryStringParameters = {
    pageNo,
    pageSize,
    beneficial_owner_id

  }
  log.logRequest('GET', routes.vaultBO + '/history', queryStringParameters)

  try {
    let res = await API.get(VAULT_ENDPOINT, routes.vaultBO + '/history', { queryStringParameters })
    log.logResponse('GET', routes.vaultBO + '/history', res)
    return res
  } catch (err) {
    throw err
  }
}

export const submitDraftDocuments = async (dispatch, vault_id, draftDocuments, onUploadProgress) => {
  dispatch({ type: actionTypes.VAULTUPDATEUPLOADINGSTATUS, payload: { status: 2 } })

  const headers = {
    'Content-Type': 'multipart/form-data',
  }

  const promises = draftDocuments
    .filter(document => document.status !== 'uploaded' || document.status !== 'uploading')
    .map(async draftDocument => {
      return new Promise((resolve, reject) => {
        const splittedNames = draftDocument.fileName.split('.')
        const formData = new FormData()
        formData.append('vault_id', vault_id)
        formData.append('vault_article', draftDocument.rawFile)
        formData.append('article_name', draftDocument.fileName)
        formData.append('article_type', splittedNames[splittedNames.length - 1])
        formData.append('article_category', draftDocument.documentType)
        formData.append('article_short_description', draftDocument.description)
        formData.append('article_description', draftDocument.description)
        formData.append('effective_date', moment(draftDocument.effectiveDate).format('YYYY-MM-DD'))
        log.logRequest('POST', routes.vaultDocument, formData)
        dispatch({
          type: actionTypes.VAULTUPDATEDRAFTDOCUMENT,
          payload: { id: draftDocument.id, status: 'uploading' },
        })
        API.post(VAULT_ENDPOINT, routes.vaultDocument, {
          headers,
          body: formData,
        })
          .then(res => {
            dispatch({
              type: actionTypes.VAULTUPDATEDRAFTDOCUMENT,
              payload: { id: draftDocument.id, status: 'uploaded' },
            })
            resolve(res)
            log.logResponse('POST', routes.vaultDocument, res)
          })
          .catch(err => {
            dispatch({
              type: actionTypes.VAULTUPDATEDRAFTDOCUMENT,
              payload: { id: draftDocument.id, status: 'failed' },
            })
            reject(err)
          })
      })
    })

  Promise.allSettled(promises)
    .then(results => { })
    .catch(err => {
      log.logError('POST', routes.vaultDocument, err)
    })
    .finally(() => {
      dispatch({ type: actionTypes.VAULTUPDATEUPLOADINGSTATUS, payload: { status: 3 } })
      fetchDocuments(dispatch, vault_id)
    })
}

export const removeDocuments = async (dispatch, vault_id, documentIds) => {
  const body = { article_id: documentIds }
  log.logRequest('POST', routes.vaultDocument + '/delete', body)

  dispatch({ type: actionTypes.VAULTFETCHINGDOCUMENTS })
  try {
    let deleteReponse = await API.post(VAULT_ENDPOINT, routes.vaultDocument + '/delete', { body })
    log.logResponse('POST', routes.vaultDocument + '/delete', deleteReponse)
  } catch (err) {
    log.logError('POST', routes.vaultDocument + '/delete', err)
  } finally {
    fetchDocuments(dispatch, vault_id)
  }
}

export const fetchingBOs = async (dispatch, vault_id, business_id, pageNo = 1, pageSize = 100) => {
  //TODO: Check if we are doing pagination on BOs as well.
  const queryStringParameters = {
    business_id,
    // pageNo,
    // pageSize,
  }
  log.logRequest('GET', routes.vaultBO, queryStringParameters)

  dispatch({ type: actionTypes.VAULTFETCHINGBOS })
  try {
    let res = await API.get(VAULT_ENDPOINT, routes.vaultBO, { queryStringParameters })
    log.logResponse('GET', routes.vaultBO, res)
    dispatch({ type: actionTypes.VAULTFETCHINGBOSDONE, payload: res })
  } catch (err) {
    dispatch({ type: actionTypes.VAULTFETCHINGBOSDONE, payload: { details: [] } })
    throw err
  }
}

export const removeBOs = async (dispatch, vault_id, business_id, boIds) => {
  //TODO: check what is required to remove BOs from backend request. Check boId fields
  const body = { beneficial_owner_id: boIds }
  log.logRequest('POST', routes.vaultDocument + '/delete', body)

  dispatch({ type: actionTypes.VAULTFETCHINGBOS })
  try {
    let deleteReponse = await API.post(VAULT_ENDPOINT, routes.vaultBO + '/delete', { body })
    log.logResponse('POST', routes.vaultBO + '/delete', deleteReponse)
    //NOTE: Once BOs are removed and re-fetch
  } catch (err) {
    throw err
  } finally {
    fetchingBOs(dispatch, vault_id, business_id)
  }
}

export const submitDraftBOs = async (dispatch, vault_id, business_id, draftBOs) => {
  dispatch({ type: actionTypes.VAULTSUBMITTINGDRAFTBOS })
  const body = {
    owner_list: draftBOs.map(bo => ({
      t_company_id: business_id,
      type: bo.ownerType[0].toUpperCase(),
      business_name: bo.bzName,
      first_name: bo.firstName,
      last_name: bo.lastName,
      email_address: bo.email,
    })),
  }

  log.logRequest('POST', routes.vaultBO, body)
  try {
    const response = await API.post(VAULT_ENDPOINT, routes.vaultBO, { body })
    log.logResponse('POST', routes.vaultBO, response)
    //NOTE: Once BOs are removed and re-fetch
    fetchingBOs(dispatch, vault_id, business_id)
    return response
  } catch (err) {
    log.logError('POST', routes.vaultBO, err)
  } finally {
    dispatch({ type: actionTypes.VAULTSUBMITTINGDRAFTBOSDONE })
  }
}

export const resendInvitation = async (vault_id, boId) => {
  const body = {
    beneficial_owner_id: boId,
  }

  log.logRequest('POST', routes.vaultBOResendInvite, body)
  try {
    const response = await API.post(VAULT_ENDPOINT, routes.vaultBOResendInvite, { body })
    log.logResponse('POST', routes.vaultBOResendInvite, response)
  } catch (err) {
    log.logError('POST', routes.vaultBO, err)
  }
}

export const fetchDeliverymathods = (callBack) => {
  API.get(VAULT_ENDPOINT, routes.vaultDeliveryMethods)
    .then(res => {
      callBack(res.details);
    })
    .catch(err => console.log(err))
}
export const fetchExpiration = (callBack) => {
  API.get(VAULT_ENDPOINT, routes.vaultExpiration)
    .then(res => {
      callBack(res.details);
    })
    .catch(err => console.log(err))
}
export const fetchRecipient = (data, callBack) => {
  API.get(VAULT_ENDPOINT, routes.vaultRecipient, {
    queryStringParameters: {
      vaultId: data.vault_id,
      name: data.name
    }
  })
    .then(res => {
      callBack(res.details);
    })
    .catch(err => console.log(err))
}
export const generatePassword = ({ vault_id }, callBack) => {
  const body = { vaultId: vault_id }
  API.post(VAULT_ENDPOINT, routes.vaultGeneratePassword, { body })
    .then(res => {
      callBack(res.details);
    })
    .catch(err => console.log(err))
}

export const triggerEmail = (body, callBack) => {
  API.post(VAULT_ENDPOINT, routes.vaultTriggerEmail, { body })
    .then(res => {
      callBack(true, false);
    })
    .catch(err => {
      callBack(false, true);
      console.log(err)
    })
}

export const triggerApprovalEmail = (body, callBack) => {
  API.post(VAULT_ENDPOINT, routes.vaultTriggerApprovalEmail, { body })
    .then(res => {
      callBack(true, false);
    })
    .catch(err => {
      callBack(false, true);
      console.log(err)
    })
}
